import { AdobeProgramTrackingFragment } from '../dataProviders/__generated__/Tracking';
import {
  UnifiedTrackingMachineLoadEvent,
  UnifiedTrackingMachineAdBeginEvent,
  UnifiedTrackingMachineAdBreakBeginEvent,
  UnifiedTrackingMachineTimeUpdateEvent,
} from '../tracking/UnifiedTrackingMachine';
import type { AdobeTrackingStrategy } from './AdobeTrackingStrategy';
import { TimeTableEntry } from './TimeTable';

/**
 * Null tracking strategy that does nothing if we get calls before a load
 */
export class AdobeNullTrackingStrategy implements AdobeTrackingStrategy {
  onLoad(event: UnifiedTrackingMachineLoadEvent): void {}

  onAdEnd(): void {}

  onAdBegin(event: UnifiedTrackingMachineAdBeginEvent): void {}

  onAdBreakEnd(): void {}

  onAdBreakBegin(event: UnifiedTrackingMachineAdBreakBeginEvent): void {}

  onTrackingEntries(entries: TimeTableEntry<AdobeProgramTrackingFragment>[]): void {}

  onTimeUpdate(event: UnifiedTrackingMachineTimeUpdateEvent): void {}

  onSeeking(): void {}

  onDestroy(): void {}

  onBuffering(): void {}

  onPause(): void {}

  onStop(): void {}
}
